import dayjs from 'dayjs';
export const FORM_INPUT_CLAIM_INSERT = ({ warranty, optionsBreakdowns }) => {
  return [
    {
      name: 'warrantyCode',
      label: 'รหัสรับประกัน',
      type: 'INPUT',
      span: 12,
      disabled: true,
      defaultValue: warranty?.warrantyCode || '',
      rules: {
        required: {
          value: true,
          message: 'ไม่พบรหัสรับประกันสินค้ากรุณาออกแล้วเข้าใหม่อีกครั้ง',
        },
      },
    },
    {
      name: 'brandMobile',
      label: 'ยี่ห้อมือถือ',
      type: 'INPUT',
      span: 12,
      disabled: true,
      defaultValue: warranty?.mobileBrandName || '',
    },
    {
      name: 'modelMobile',
      label: 'รุ่นมือถือ',
      type: 'INPUT',
      span: 12,
      disabled: true,
      defaultValue: warranty?.mobileModelName || '',
    },
    {
      name: 'breakdownId',
      label: 'อาการเสียของกระจกกันรอย',
      type: 'DROPDOWN',
      placeholder: 'เลือกอาการเสียของกระจกกันรอย',
      span: 12,
      properties: {
        options: optionsBreakdowns || [],
      },
      rules: {
        required: {
          value: true,
          message: 'กรุณาเลือกอาการเสียของกระจกกันรอย',
        },
      },
      style: { width: '100%', height: '100%', minHeight: '32px' },
    },
    // {
    //   name: 'detail1',
    //   label: 'รายละเอียดเพิ่มเติม',
    //   type: 'INPUT',
    //   placeholder: 'กรอกรายละเอียดเพิ่มเติม',
    //   span: 12,
    //   maxLength: 250,
    // },
  ];
};

export const FORM_SHOW_IMAGE_CLAIM = () => {
  return [
    {
      name: 'claimImage',
      label: 'ถ่ายภาพสินค้าที่เกิดปัญหาหรือแนบรูปภาพสินค้าที่เกิดปัญหา',
      type: 'UPLOAD_TWO',
      span: 12,
      rules: {
        required: {
          value: true,
          message: 'กรุณาถ่ายภาพหรือเลือกภาพสินค้าที่ต้องการเคลม',
        },
      },
    },
  ];
};

export const FORM_SELECT_CHANNEL_CLAIM = ({
  storeNameOptions,
  channelClaimOptions,
  channelClaimCode,
}) => {
  const SHOW_DATE_CLAIM = [
    {
      name: 'bookingDate',
      label: 'จองวันเคลมสินค้า',
      type: 'DATE_PICKER',
      span: 12,
      rules: {
        required: true,
      },
      disabledDate: (current) => {
        const minDate = dayjs().add(2, 'day').startOf('day');
        return current && current < minDate;
      },
    },
  ];
  const SHOW_STORE_NAME = [
    {
      name: 'storeId',
      label: 'ร้านค้า',
      type: 'DROPDOWN',
      span: 12,
      rules: {
        required: true,
      },
      properties: {
        options: storeNameOptions || [],
      },
    },
  ];
  return [
    {
      name: 'channelClaimId',
      label: 'ช่องทางรับสินค้าเคลม',
      type: 'DROPDOWN',
      span: 12,
      properties: {
        options: channelClaimOptions || [],
      },
      defaultValue: channelClaimOptions[0]?.value,
      rules: {
        required: true,
      },
    },
    ...(channelClaimCode === 'FOCUS' || channelClaimCode === 'STORE' ? SHOW_STORE_NAME : []),
    ...(channelClaimCode === 'FOCUS' ? SHOW_DATE_CLAIM : []),
  ];
};

export const FORM_INPUT_CLAIM_ADDRESS = ({
  optionsOldAddress,
  watch,
  optionsProvinces,
  optionsDistricts,
  optionsSubDistricts,
  onZipCodeEnter,
  onProvinceSelected,
  onDistrictSelected,
  onOldAddressSelected,
  onNewAddressRaioSelected,
}) => {
  return [
    {
      name: 'isCreateNewAddress',
      label: 'ที่อยู่จัดส่ง',
      type: 'RADIO',
      span: 12,
      defaultValue: true,
      disabled: true,
      properties: {
        options: [
          { label: 'ที่อยู่เดิม', value: false },
          { label: 'เพิ่มที่อยู่ใหม่', value: true },
        ],
      },
      onChange: (data) => {
        onNewAddressRaioSelected(data.target.value);
      },
    },
    ...(!watch('isCreateNewAddress')
      ? [
          {
            name: 'oldAddresses',
            label: 'เลือกที่อยู่',
            type: 'DROPDOWN_TWO',
            placeholder: 'เลือกที่อยู่',
            span: 12,
            properties: {
              options: optionsOldAddress || [],
            },
            onChange: (data, item) => {
              onOldAddressSelected(item.value);
            },
            style: {
              height: 'auto',
              maxHeight: '200px',
              width: '100%',
              overflowY: 'auto',
              overflowWrap: 'break-word',
              whiteSpace: 'normal',
            },
          },
        ]
      : []),
    {
      name: 'zipCode',
      label: 'รหัสไปรษณีย์',
      type: 'INPUT',
      placeholder: 'กรอกรหัสไปรษณีย์',
      span: 12,
      maxLength: 5,
      disabled: !watch('isCreateNewAddress'),
      rules: {
        required: true,
      },
      onEnter: (data) => {
        onZipCodeEnter(data);
      },
    },
    {
      name: 'provinceId',
      label: 'จังหวัด',
      type: 'DROPDOWN',
      placeholder: 'เลือกจังหวัด',
      span: 12,
      disabled: !watch('isCreateNewAddress'),
      properties: {
        options: optionsProvinces || [],
      },
      rules: {
        required: true,
      },
      onChange: (data, item) => {
        onProvinceSelected(item.value);
      },
    },
    {
      name: 'districtId',
      label: 'เขต/อำเภอ',
      type: 'DROPDOWN',
      placeholder: 'เลือกเขต/อำเภอ',
      span: 12,
      disabled: !watch('isCreateNewAddress'),
      properties: {
        options: optionsDistricts || [],
      },
      rules: {
        required: true,
      },
      onChange: (data, item) => {
        onDistrictSelected(item.value);
      },
    },
    {
      name: 'subDistrictId',
      label: 'แขวง/ตำบล',
      type: 'DROPDOWN',
      placeholder: 'เลือกแขวง/ตำบล',
      span: 12,
      disabled: !watch('isCreateNewAddress'),
      properties: {
        options: optionsSubDistricts || [],
      },
      rules: {
        required: true,
      },
    },
    {
      name: 'other',
      label: 'รายละเอียดที่อยู่ (บ้านเลขที่/ถนน/หมู่ที่/หมู่บ้าน)',
      type: 'INPUT_AREA',
      placeholder: 'กรอกรายละเอียดที่อยู่',
      span: 12,
      maxLength: 255,
      rules: {
        required: true,
      },
    },
  ];
};

export const FORM_BILL = () => {
  return [
    {
      name: 'receiptImage',
      label: 'รูปสลิปค่าดำเนินการเคลม',
      type: 'UPLOAD',
      listType: 'picture-card',
      span: 12,
      rules: {
        required: {
          value: true,
          message: 'กรุณาอัพโหลดรูปสลิปค่าดำเนินการเคลม',
        },
      },
      maxCount: 1,
    },
  ];
};
